import React, { useEffect, useState } from "react";
import { withBreakpoints } from "react-breakpoints";

import Slide from "react-reveal/Slide";
import HeadShake from "react-reveal/HeadShake";
import ClickAwayListener from "react-click-away-listener";

import theme, {
  navbarHeight,
  roundness,
  stack,
  styles as commonStyles,
} from "../../../utils/styles";

import data from "../../../data/navigation";

const Navigation = (props) => {
  const { logoPath, links } = data;
  const { breakpoints, currentBreakpoint } = props;
  const isBreakpoint =
    breakpoints[currentBreakpoint] < breakpoints.tabletLandscape;

  const [buttonHover, setButtonHover] = useState(false);
  const [logoHover, setLogoHover] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [scrolling, setScrolling] = useState(false);

  const handleScroll = () => {
    const scrolled = Math.floor(window.pageYOffset);

    if (scrolled > 100) setScrolling(true);
    else setScrolling(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  });

  const executeScroll = (id) => {
    if (document.location.pathname === "/") {
      if (id[0] === "/") {
        window.location.href = id;
      } else {
        const traget = document.getElementById(id);
        window.history.pushState({}, "", "/" + id);
        traget.scrollIntoView();
      }
    } else {
      if (id[0] !== "/") {
        window.location.href = "/" + id;
      }
    }
  };

  useEffect(() => {
    const id = document.location.hash;
    const traget = document.getElementById(id);
    if (traget != null) traget.scrollIntoView();
  }, []);

  const renderDesktopLogo = (
    <img
      src={logoPath}
      alt="Genes And Machines"
      style={styles.logo(logoHover)}
      onMouseEnter={(e) => {
        setLogoHover(true);
      }}
      onMouseLeave={(e) => {
        setLogoHover(false);
      }}
      onClick={(e) => executeScroll("#landing")}
    />
  );

  const renderMobileLogo = (
    <img
      src={logoPath}
      alt="Genes And Machines"
      style={styles.logo(logoHover)}
      onClick={(e) => setMobileMenuOpen(!mobileMenuOpen)}
    />
  );

  const renderLogo = isBreakpoint ? renderMobileLogo : renderDesktopLogo;

  const renderMobileMenu = mobileMenuOpen ? (
    <Slide bottom>
      <ClickAwayListener onClickAway={(e) => setMobileMenuOpen(false)}>
        <div style={styles.mobileMenu}>
          <NavigationLink
            item={{
              text: "Home",
              url: "#landing",
            }}
            executeScroll={executeScroll}
            setMobileMenuOpen={setMobileMenuOpen}
          />
          {links.map((item, index) => (
            <NavigationLink
              item={item}
              key={index}
              executeScroll={executeScroll}
              setMobileMenuOpen={setMobileMenuOpen}
            />
          ))}
        </div>
      </ClickAwayListener>
    </Slide>
  ) : null;

  return (
    <Slide top>
      <div style={styles.root}>
        <div style={styles.flex(scrolling)}>
          <div>
            <div style={styles.centered(scrolling)}>{renderLogo}</div>
          </div>
          {isBreakpoint ? null : (
            <div style={styles.flexColumn(1)}>
              <div style={styles.centered(scrolling)}>
                {links.map((item, index) => (
                  <NavigationLink
                    item={item}
                    key={index}
                    executeScroll={executeScroll}
                    setMobileMenuOpen={() => {}}
                  />
                ))}
              </div>
            </div>
          )}
          <div>
            <div style={styles.centered(scrolling)}>
              <HeadShake when={buttonHover}>
                <button
                  style={commonStyles.ctaButton(isBreakpoint || buttonHover)}
                  onMouseEnter={(e) => {
                    setButtonHover(true);
                  }}
                  onMouseLeave={(e) => {
                    setButtonHover(false);
                  }}
                  onClick={(e) => executeScroll("#contact")}
                >
                  Get in touch
                </button>
              </HeadShake>
            </div>
          </div>
        </div>
        {renderMobileMenu}
      </div>
    </Slide>
  );
};

export default withBreakpoints(Navigation);

const NavigationLink = (props) => {
  const { item, executeScroll, setMobileMenuOpen } = props;
  const [hover, setHover] = useState(false);

  return (
    <button
      style={styles.navigationLink(hover)}
      onMouseEnter={(e) => {
        setHover(true);
      }}
      onMouseLeave={(e) => {
        setHover(false);
      }}
      onClick={(e) => {
        executeScroll(item.url);
        setMobileMenuOpen(false);
      }}
    >
      {item.text}
    </button>
  );
};

const styles = {
  root: {
    position: "fixed",
    zIndex: stack.navigationBar,
    width: "100%",
  },
  flex: (scrolling) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: theme.colors.backgroundFaded,
    boxShadow: "0px 0px 10px 5px rgb(0,0,0,0.2)",
    borderRadius: roundness.card,
    transition: "ease-in-out 0.5s",
    paddingLeft: "3vw",
    paddingRight: "3vw",
    margin: scrolling ? 10 : 20,
  }),
  flexColumn: (size) => ({
    flexGrow: size,
  }),
  centered: (scrolling) => ({
    height: scrolling ? navbarHeight - 10 : navbarHeight,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "ease-in-out 0.5s",
  }),
  logo: (hover) => ({
    height: hover ? navbarHeight - 20 : navbarHeight - 30,
    transition: "ease-in-out 0.2s",
    cursor: "pointer",
  }),

  navigationLink: (hover) => ({
    padding: 10,
    width: 130,
    color: "white",
    marginLeft: 10,
    marginRight: 10,
    transition: "ease-in-out 0.5s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    background: hover ? "rgb(256,256,256,0.1)" : "transparent",
    borderStyle: "none",
    borderRadius: roundness.button,
    fontWeight: "bold",
  }),
  mobileMenu: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    flexDirection: "column",
    background: theme.colors.backgroundFaded,
    boxShadow: "0px 0px 10px 5px rgb(0,0,0,0.2)",
    borderRadius: roundness.card,
    transition: "ease-in-out 0.5s",
    borderStyle: "solid none",
    borderColor: "#00000000",
    margin: 20,
    rowGap: 20,
    borderWidth: 20,
  },
};
